import React, { useState, useEffect } from "react";
import {
  useGetSellerCartDataDependentQuery,
  useAcceptPaymentBySellerMutation,
  useNegotiationTimelineMutation,
  usePostCheckAvailabilityMutation,
} from "./ProcurementApiSlice";
import { Modal } from "react-bootstrap";
import SellerIndependentNegotiationModal from "./SellerIndependentNegotiationModal";
import SellerDispatch from "./SellerDispatch";
import QualityParamsModal from "./QualityParamsModal";
import CancelIcon from "@mui/icons-material/Cancel";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { toast } from "react-toastify";
import {
  Popover,
  IconButton,
  Typography,
  MenuItem,
  Button,
  Select,
  Card,
  CardContent,
  Grid,
  Box,
  Divider,
} from "@mui/material";
import InvoiceGenerationAdmin from "./InvoiceGenerationAdmin";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import Swal from "sweetalert2";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import SkeletonLoader from "./SkeletonLoader";
import NoData from "features/MobileProcurement/NoData";
import { DetailDescriptionSeller } from "./DetailDescriptionSeller";
const SellerDependentCart = ({ user_id, setActiveCard, triggerTab2Api,alternateClick }) => {
  const {
    data: getStockWiseCommodity,
    isLoading,isFetching,
    refetch,
  } = useGetSellerCartDataDependentQuery(user_id, {
    refetchOnMountOrArgChange: true,
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [acceptPayment] = useAcceptPaymentBySellerMutation();
  const [increaseTimeline] = useNegotiationTimelineMutation();
  const [checkAvailability] = usePostCheckAvailabilityMutation();
  const [CommodityData, setCommodityData] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, per_page: 10 });
  const [negotiationModal, setNegotiationModal] = useState(false);
  const [negotiationItem, setNegotiationItem] = useState("");
  const [qualityParams, setQualityParams] = useState("");
  const [BuyersActiveList, setBuyersActiveList] = useState("");
  const [FullList, setFullList] = useState([]);
  const [show, setShow] = useState(false);
  const [stockId, setStockId] = useState("");
  const [isRefetching, setIsRefetching] = useState(false);

  const handleClose = () => setShow(false);
  useEffect(() => {
    if (getStockWiseCommodity) {
      setCommodityData(getStockWiseCommodity?.data?.results);
    }
  }, [getStockWiseCommodity]);
  //  useEffect=(()=>{
  //   if(triggerTab2Api){
  //     refetch()
  //   }
  //  },[triggerTab2Api])
  useEffect(() => {

    if (triggerTab2Api) {
      const fetchData = async () => {
        setIsRefetching(true);
        await refetch();
        setIsRefetching(false);
      };
      fetchData();
    }
  }, [triggerTab2Api,alternateClick]);

  const [anchorEl, setAnchorEl] = useState(false);
  const handlePopoverClose = () => {
    setAnchorEl(false);
  };
  const handleNegotiation = (item) => {
    let formData = {
      crop_id: item.crop_code,
      user_id: user_id,
      quantity: item.quantity,
    };
    setStockId(item.id);
    if (item.status === "Started") {
      checkAvailability(formData)
        .unwrap()
        .then((data) => {
          console.log("data",data)

          if (data.status === 200 && data?.data?.available_stock>=item?.quantity) {
            console.log("data",data)
            setNegotiationModal(true);
            setNegotiationItem(item);
            setBuyersActiveList(item);
          } else {
            Swal.fire({
              title: "Insufficient Stock",
              text: `Available Stock is ${data?.data?.available_stock}`,
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Continue",
              cancelButtonText: "Cancel",
              confirmButtonIcon: "fas fa-arrow-right",
            }).then((result) => {
              if (result.isConfirmed) {
                setActiveCard("Commodity");
              }
            });
          }
        })
        .catch((data) => {
          Swal.fire({
            title: "Insufficient Stock",
            text: data?.data?.message,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Continue",
            cancelButtonText: "Cancel",
            confirmButtonIcon: "fas fa-arrow-right",
          }).then((result) => {
            if (result.isConfirmed) {
              setActiveCard("Commodity");
            }
          });
          return;
        });
    } else {
      setNegotiationModal(true);
      setNegotiationItem(item);
      setBuyersActiveList(item);
    }
  };
  const handleDispatchModal = (list) => {
    setShow(true);
    setFullList(list);
    setAnchorElDo(null);
    setstockUserId(list.created_for_id);
    setstockCropId(list.crop_code);
  };

  const [anchorElPayment, setAnchorElPayment] = useState(null);
  const handlePopoverClosePayment = () => {
    setAnchorElPayment(null);
  };
  const handlePopoverOpenPayment = (event, list) => {
    setAnchorElPayment(event.currentTarget);
    setFullList(list);
    setAnchorElDo("");
  };
  const [anchorElDo, setAnchorElDo] = useState(null);
  const handleUploadIconClick = (event, list) => {
    setAnchorElDo(event.currentTarget);
    setFullList(list);
  };
  const handleCloseDo = () => {
    setAnchorElDo(null);
  };
  const [BillModal, setBillModal] = useState(false);
  const [stockUserId, setstockUserId] = useState("");
  const [stockCropId, setstockCropId] = useState("");
  const handleShipment = (row) => {
    setAnchorElDo(null);
    setBillModal(true);
    setFullList(row);
    setstockUserId(row.created_for_id);
    setstockCropId(row.crop_code);
  };
  const [anchorElInvoice, setAnchorElInvoice] = useState(null);
  const handleGenerateInvoice = (event, list) => {
    setAnchorElInvoice(event.currentTarget); // Set the anchor element to the icon clicked
    setFullList(list);
  };

  const handleCloseInvoice = () => {
    setAnchorElInvoice(null); // Close the popover
  };
  const [anchorTimeline, setanchorTimeline] = useState(null);
  const [selectedDay, setSelectedDay] = useState("");
  const handlePopoverCloseTimeline = () => {
    setanchorTimeline(null);
  };
 
  const handleIncreaseTimeline = () => {
    let id = FullList.ProcCode;
    let payload = {
      valid_until: selectedDay === 1 ? "24" : selectedDay === 2 ? "48" : "72",
    };
    increaseTimeline({ id: id, payload: payload })
      .unwrap()
      .then(async (data) => {
        toast.success("Timeline Updated !!");
        setanchorTimeline(null);
        setFullList("");
        setSelectedDay("");
        await refetch();
      })
      .catch((error) => {
        toast.error("Something went wrong !!");
        return;
      });
  };

  const handleViewPdf = (url) => {
    window.open(url, "_blank");
  };
  const [paymentsheetloader, setpaymentsheetloader] = useState(false);
  const handleAccept = (val, item, index) => {
    setpaymentsheetloader(true);
    let payload;
    if (val === "Payment Received")
      payload = {
        status: val,
        entity_type: "Seller",
        payment_id: item.id,
      };
    else
      payload = {
        status: val,
        entity_type: "Seller",
      };
    let id =
      FullList?.entity_type === "Seller"
        ? FullList?.trade_procCode
        : FullList?.ProcCode;
    acceptPayment({ id: id, payload: payload })
      .unwrap()
      .then(async (data) => {
        toast.success("Successfully Updated !!");
        await refetch();
        setpaymentsheetloader(false);
        setAnchorElDo(null);
        setAnchorElPayment(null);
      })
      .catch((error) => {
        toast.error("Something went wrong !!");
        setpaymentsheetloader(false);
        return;
      });
  };


  const handleStatus = (row) => {
    const {
      status,
      dispatch_status,
      delivery_status,
      document_status,
      payments,
    } = row || {};

    let displayStatus = status;
    if(status==="Closed"){
        return displayStatus
    }
    if (dispatch_status !== "Pending" && delivery_status === "Pending") {
      displayStatus = dispatch_status;
    } else if (delivery_status !== "Pending" && dispatch_status !== "Pending") {
      displayStatus = delivery_status;
    }

    if (document_status.payment_sheet_partner && status === "Completed") {
      displayStatus = status;
    }
    if (document_status.payment_sheet_partner && status !== "Completed") {
      displayStatus = payments.partner_status;
    }
    return displayStatus;
  };
  return (
    <div className="row ">
      {isLoading || isRefetching || isFetching ? (
        <SkeletonLoader />
      ) : CommodityData?.length > 0 ? (
        <Grid container spacing={2} style={{ marginTop: "-40px" }}>
          {CommodityData?.map((row, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                variant="outlined"
                sx={{
                  padding: 2,
                  borderRadius: "12px",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                  transition: "transform 0.3s",
                  "&:hover": { transform: "scale(1.02)" },
                }}
              >
                {/* Card Header */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: {  sm: "row" },
                    alignItems: { xs: "center", sm: "flex-start" },
                    marginBottom: 1.5,
                  }}
                >
                  {/* Image */}
                  {row.image_url && (
                    <Box
                      component="img"
                      src={row.image_url}
                      alt={row.crop_name}
                      sx={{
                        width: "70px",
                        height: "70px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        marginBottom: { xs: 1, sm: 0 },
                        marginRight: { sm: 2 },
                      }}
                    />
                  )}

                  {/* Content */}
                  <Box
                    sx={{ flex: 1, textAlign: { xs: "center", sm: "left" } }}
                  >
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                      {row.crop_name.replace(/_/g, " ")}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{ color: "text.secondary" }}
                    >
                      Created: {row.created_at.slice(0, 10)}
                    </Typography>
                  </Box>
                  {(row.status === "Purchase Order Uploaded" ||
                    row?.document_status?.b2s_invoice ||
                    row.status === "Invoice In Progress") && (
                    <IconButton
                      size="small"
                      onClick={(e) => handleUploadIconClick(e, row)}
                      sx={{ alignSelf: "flex-start", marginLeft: "auto" }}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  )}
                </Box>

                {/* Card Content */}
                <CardContent sx={{ paddingTop: 0 }}>
                  {/* Quantity and Price */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: { sm: "row" },

                      flexWrap: "wrap",
                      marginBottom: 1,
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary" }}
                    >
                      Quantity:{" "}
                      <strong>
                        {row?.final_quantity === 0.0 ||
                        row?.final_quantity === 0
                          ? row?.quantity
                          : row?.final_quantity}{" "}
                        {row.unit_of_measure}
                      </strong>
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary" }}
                    >
                      Price/Unit:{" "}
                      <strong>
                        {" "}
                        ₹{" "}
                        {row?.final_price === 0.0 || row?.final_price === 0
                          ? row?.price
                          : row?.final_price}
                      </strong>
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexWrap: { xs: "wrap", sm: "nowrap" },
                      marginBottom: 1,
                    }}
                  >
                    <Typography
                      variant="caption"
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      <AccessTimeIcon
                        fontSize="small"
                        sx={{ marginRight: 0.5 }}
                      />
                      Payment :   {row?.delivery_and_payment_detail?.payment_type}{" "}
                      {row.delivery_and_payment_detail?.payment_type === "D+"
                        ? "("+row.delivery_and_payment_detail?.payment_timeline +
                          " Days)"
                        : ""}
                    </Typography>
                    <Typography variant="caption">
                      Est Delivery:{" "}
                      {row.delivery_and_payment_detail.delivery_timeline} Days
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexWrap: { xs: "wrap", sm: "nowrap" },
                    }}
                  >
                    <Typography
                      variant="caption"
                      sx={{ fontWeight: 500, color: "#69829f" }}
                    >
                      Status:{" "}
                      <span style={{ color: "orange" }}>
                        {handleStatus(row)}
                      </span>
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 500,
                        color: "primary.main",
                        marginBottom: 1,
                      }}
                    >
                      Total: ₹
                      {row?.final_price === 0.0 || row?.final_price === 0
                        ? row?.price * row?.quantity
                        : row?.final_price * row?.final_quantity}
                    </Typography>
                  </Box>

                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {/* Buyers Button with Border */}
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#333",
                        fontWeight: "500",
                        cursor: "pointer",
                        borderRadius: "8px",
                        backgroundColor: "#3333", // Light gray background

                        padding: "4px 8px",
                        transition: "background-color 0.3s",
                        "&:hover": {
                          color: "#ff8000",
                          backgroundColor: "#fff8e1", // Light background on hover
                        },
                      }}
                      onClick={() => handleNegotiation(row)}
                    >
                      BID &rarr;
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        backgroundColor: "#f4f4f4", // Light gray background
                        borderRadius: "12px",
                        padding: "4px 8px",
                        cursor: "pointer",
                        transition: "background-color 0.3s",
                        "&:hover": { backgroundColor: "#e0e0e0" },
                      }}
                      onClick={(e) => handleGenerateInvoice(e, row)}
                    >
                      <Typography
                        variant="body2"
                        sx={{ color: "#333", fontWeight: "500" }}
                      >
                        View Details &rarr;
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <NoData val="trade" />
      )}

      <Popover
        open={Boolean(anchorElDo)}
        anchorEl={anchorElDo}
        onClose={handleCloseDo}
        anchorOrigin={{
          vertical: "center", // Align vertically with the middle of the row
          horizontal: "right", // Open to the right of the row
        }}
        transformOrigin={{
          vertical: "center", // Align the popover content to the middle of its trigger
          horizontal: "left", // Open the content from the left of the popover
        }}
        PaperProps={{ style: { maxWidth: "300px", padding: "16px" } }} // Adjust spacing
      >
        <CancelIcon
          fontSize="small"
          style={{
            color: "#1976D2",
            float: "right",
            cursor: "pointer",
            marginBottom: "10px",
          }}
          onClick={handleCloseDo}
        />

        <div>
          <div style={{ marginBottom: "10px" }}>
            <h6 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: "#1976D2",
                }}
              ></span>
              Invoice Generation
            </h6>
            <p style={{ marginLeft: "18px", fontSize: "14px", color: "#666" }}>
              <span
                className="steelblue cursor-pointer"
                style={{ cursor: "pointer" }}
                onClick={() => handleShipment(FullList)}
              >
                Click
              </span>{" "}
              to <b>Generate</b> Invoice.
            </p>
          </div>

          <div style={{ marginBottom: "10px" }}>
            <h6 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: FullList?.document_status?.b2s_invoice
                    ? "#1976D2"
                    : "#CCC",
                }}
              ></span>
              Dispatch Documents
            </h6>
            <p style={{ marginLeft: "18px", fontSize: "14px", color: "#666" }}>
              <span
                className="steelblue cursor-pointer"
                style={{
                  cursor: FullList?.document_status?.b2s_invoice
                    ? "pointer"
                    : "not-allowed",
                }}
                onClick={
                  FullList?.document_status?.b2s_invoice
                    ? () => handleDispatchModal(FullList)
                    : undefined
                }
              >
                Click
              </span>{" "}
              to upload your <b>Dispatch</b> documents.
            </p>
          </div>

          <div style={{ marginBottom: "10px" }}>
            <h6 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: FullList?.document_status?.delivered
                    ? "#1976D2"
                    : "#CCC",
                }}
              ></span>
              Delivery & Payments Documents
            </h6>
            <p style={{ marginLeft: "18px", fontSize: "14px", color: "#666" }}>
              Wait till the time documents are uploaded.
            </p>
          </div>

          <div style={{ marginBottom: "10px" }}>
            <h6 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: FullList?.document_status?.delivered
                    ? "#1976D2"
                    : "#CCC",
                }}
              ></span>
              Document Action
            </h6>
            <p style={{ marginLeft: "18px", fontSize: "14px", color: "#666" }}>
              <span
                className="steelblue cursor-pointer"
                style={{
                  cursor: FullList?.document_status?.payment_proof_partner
                    ? "pointer"
                    : "not-allowed",
                }}
                onClick={
                  FullList?.document_status?.payment_proof_partner
                    ? (e) => handlePopoverOpenPayment(e, FullList)
                    : undefined
                }
              >
                Click
              </span>{" "}
              to <b>Accept</b> documents.
            </p>
          </div>

          <div style={{ marginBottom: "10px" }}>
            <h6 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor:
                    FullList?.status === "Completed" ? "#1976D2" : "#CCC",
                }}
              ></span>
              Trade Completion
            </h6>
            <p style={{ marginLeft: "18px", fontSize: "14px", color: "#666" }}>
              Please wait for admin approval to mark the trade as completed.
            </p>
          </div>
        </div>
      </Popover>

      <Modal
        show={negotiationModal}
        onHide={() => setNegotiationModal(false)}
        size="xm"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">
            Negotiate with{" "}
            <span style={{ color: "#1976d2" }}>
              {negotiationItem?.created_name}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3">
          <SellerIndependentNegotiationModal
            negotiationItem={negotiationItem}
            setNegotiationModal={setNegotiationModal}
            user_id={user_id}
            BuyersList={BuyersActiveList}
            UserType="Seller"
            refetch={refetch}
            setWidth=""
            stockId={stockId}
          />
        </Modal.Body>
      </Modal>
      <Modal show={anchorEl} onHide={handlePopoverClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "" }} className="fw-bold">
            Quality Parameters
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "2%" }}>
          <QualityParamsModal qualityParams={qualityParams} />
        </Modal.Body>
      </Modal>
      <Modal show={show} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>
            Dispatch Documents ({" "}
            <b className="text-warning mx-1">
              Trade Qty : {FullList?.final_quantity} Quintals
            </b>{" "}
            )
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div class="row mt-2">
            {/* <SellerDispatch FullList={FullList} user_id={user_id} /> */}
            <SellerDispatch
              FullList={FullList}
              user_id={user_id}
              refetch={refetch}
              handleClose={handleClose}
              value=""
              stockUserId={stockUserId}
              stockCropId={stockCropId}
            />
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={BillModal} size="md" onHide={() => setBillModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            Generate Invoice ( Trade Quantity : {FullList.final_quantity} &nbsp;
            {FullList.unit_of_measure} )
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4" style={{ backgroundColor: "#F8F8F8" }}>
          <InvoiceGenerationAdmin
            stockUserId={stockUserId}
            stockCropId={stockCropId}
            procList={FullList}
            setBillModal={setBillModal}
            refetch={refetch}
            entity_type="Seller"
          />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>

      <Modal show={anchorElInvoice} onHide={handleCloseInvoice} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <DetailDescriptionSeller
            data={FullList}
            invoice="invoice_1"
            procCode={FullList.ProcCode}
            type="Seller"
            showBuyerName={true}
            user_id={user_id}
          />
          <Divider sx={{ margin: "10px 0" }} />
        </Modal.Body>
      </Modal>

      <Popover
        open={Boolean(anchorTimeline)}
        anchorEl={anchorTimeline}
        onClose={handlePopoverCloseTimeline}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{ style: { maxWidth: "260px", padding: "16px" } }}
      >
        <IconButton
          size="small"
          style={{ color: "#1976D2", float: "right" }}
          onClick={handlePopoverCloseTimeline}
        >
          <CancelIcon fontSize="small" />
        </IconButton>

        <Typography variant="subtitle1" gutterBottom>
          Modify Timeline
        </Typography>

        <div style={{ marginTop: "10px" }}>
          <Select
            value={selectedDay}
            onChange={(e) => setSelectedDay(e.target.value)}
            displayEmpty
            fullWidth
            size="small"
            style={{ marginBottom: "10px" }}
          >
            <MenuItem value="" disabled>
              Select Days
            </MenuItem>
            <MenuItem value={1}>1 Day</MenuItem>
            <MenuItem value={2}>2 Days</MenuItem>
            <MenuItem value={3}>3 Days</MenuItem>
          </Select>

          <Button
            variant="contained"
            color="primary"
            onClick={handleIncreaseTimeline}
            size="small"
            fullWidth
          >
            Submit
          </Button>
        </div>
      </Popover>
      <Modal
        show={anchorElPayment}
        onHide={handlePopoverClosePayment}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        size="md"
      >
        <Modal.Header closeButton style={{ backgroundColor: "lightgrey" }}>
          <Modal.Title>Payment Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12 p-2">
              <h6>
                Payment Status :{" "}
                <span className="text-warning">
                  {FullList?.payments?.partner_status}
                </span>
              </h6>
           
              <div
                style={{
                  padding: "10px",
                  borderRadius: "8px",
                  lineHeight: "1.6",
                }}
              >
                {FullList?.payment_records?.map((item, index) => {
                  if (item.has_partner_paid) {
                    return (
                      <div
                        key={index}
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "6px",
                          padding: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        {/* Row 1: Amount and Payment Type */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "8px",
                          }}
                        >
                          <div>
                            <b>Amount:</b> <span>₹ {item.amount}</span>
                          </div>
                          <div>
                            
                            <span>
                              {item.file ? (
                                <span
                                  className="text-warning cursor-pointer"
                                  onClick={() => handleViewPdf(item.file)}
                                >
                                  <PictureAsPdfIcon />
                                </span>
                              ) : (
                                ""
                              )}
                            </span>
                          </div>
                        </div>

                        {/* Row 2: Payment Method and Status */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <b>Payment Method:</b>{" "}
                            <span>{item.payment_method==="Discount"?"C/D":item.payment_method}</span>
                          </div>
                          <div>
                           
                            {!item.is_confirmed ? (
                              <>
                                <span
                                  className="badge badge-success cursor-pointer mx-2"
                                  onClick={() =>
                                    handleAccept("Payment Received", item)
                                  }
                                >
                                  Accept
                                </span>
                              </>
                            ) : (
                              <span className="cursor-pointer text-warning f300 mx-2">
                                Approved
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  }
                  return null;
                })}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SellerDependentCart;
